<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div v-if="waitingLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="waitingError" class="mc-error">{{ waitingError }}</div>
      <div v-if="waitingLoaded" class="mc-products mc-products--waiting-list">
        <div class="mc-products__number">
          {{waiting.length}} товара
        </div>
        <ul class="mc-products__list">
          <li  v-for="product in waiting" class="mc-products__item">
            <div class="mc-product-card">
              <ul class="mc-product-card__tools mc-card-tools">
                <li class="mc-card-tools__item">
                  <button @click="remove(product.item_ids)" class="mc-card-tools__button simulated-hover" type="button" aria-label="Удалить">
                    <svg class="mc-card-tools__icon" width="20" height="20" viewBox="0 0 20 20">
                      <use xlink:href="/assets/svg/sprite.svg#icon-cross-1"></use>
                    </svg>
                  </button>
                </li>
              </ul>
              <router-link class="mc-product-card__image-link" :to="'/detail/'+product.id+'/'">
                <img class="mc-product-card__image" :src="product.picture" width="158" height="262" :alt="product.name || ''">
              </router-link>
              <div class="mc-product-card__body">
                <div class="mc-product-card__title">
                  <router-link class="mc-product-card__title-link" :to="'/detail/'+product.id+'/'">
                    {{ product.name }}
                  </router-link>
                </div>
                <div class="mc-product-card__price">
        <span v-if="product.price_old > product.price" class="mc-product-card__price-old">
          {{ product.price_old }}
        </span>
                  <span class="mc-product-card__price-current">
          {{ product.price }} ₽
        </span>
                </div>
                <div class="mc-product-card__size">
                  {{ product.size }}
                </div>
              </div>
              <div class="mc-product-card__bottom">
                <button @click="addToBasket(product.offer_id)" class="mc-button mc-button--color" type="button" :class="{isHidden:product.available=='N' || (counterBasketData.ids && counterBasketData.ids.includes(product.offer_id))}">
                                        <span class="mc-button__text">
                                            В корзину
                                        </span>
                </button>
                <router-link to="/basket/" class="mc-button"  v-if="(counterBasketData.ids && counterBasketData.ids.includes(product.offer_id))">В корзине</router-link>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from "axios";

export default {
  beforeRouteLeave(to, from) {
    //if (to.name != 'login')
    //  this.$store.dispatch('unLoader');
  },
  created() {
    this.fetchWaiting();
  },
  computed: {
    ...mapGetters([
      'waiting',
      'waitingLoading',
      'waitingError',
      'waitingLoaded',
      'counterBasketData'
    ]),
  },
  async mounted() {

  },
  methods: {
    ...mapActions([
      'fetchWaiting'
    ]),
    async remove(id) {
      const response = await axios.post('api/catalog/waiting/remove/', {ids: id},
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
      if (response.data.status == 'success') {
        this.fetchWaiting();
      }
    },
    addToBasket(id) {
      this.$store.dispatch('addToBasket', {productId:id, quantity: 1});
    },
  },
  data: () => ({
    sortShow: false
  }),
  components: {

  }
}
</script>
